import { render, staticRenderFns } from "./AccountProjectNavbarItem.vue?vue&type=template&id=636a6d6c&scoped=true&"
import script from "./AccountProjectNavbarItem.vue?vue&type=script&lang=js&"
export * from "./AccountProjectNavbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a6d6c",
  null
  
)

export default component.exports